<div class="detalle-modal">
  <div class="detalle-header">
    <div class="detalle-header-titles">
      <h2>Detalle Cotización</h2>
      <span class="detalle-header-beneficiario" *ngIf="data.nombreBeneficiario">{{ data.nombreBeneficiario }}</span>
    </div>
    <button mat-icon-button type="button" aria-label="Cerrar" (click)="cerrar()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="detalle-body" [class.detalle-body--solo-datos]="data.ocultarLiquidacionProntoPago">
    <section class="detalle-left">
      <div class="field-grid">
        <div class="field-item">
          <label>Línea de negocio:</label>
          <div class="value-box">{{ data.lineaNegocio }}</div>
        </div>
        <div class="field-item">
          <label>Programa:</label>
          <div class="value-box">{{ data.programa }}</div>
        </div>

        <div class="field-item">
          <label>Tarifa mensual sin anexos:</label>
          <div class="value-box money">$ {{ formatCurrency(data.tarifaMensual) }}</div>
        </div>
        <div class="field-item">
          <label>Descripción:</label>
          <div class="value-box">{{ data.descripcionTarifa }}</div>
        </div>

        <div class="field-item">
          <label>Campaña:</label>
          <div class="value-box">{{ data.campaniaCodigo }}</div>
        </div>
        <div class="field-item">
          <label>Nombre campaña:</label>
          <div class="value-box">{{ data.campaniaNombre }}</div>
        </div>

        <div class="field-item">
          <label>Inicio vigencia campaña:</label>
          <div class="value-box">{{ data.campaniaInicioVigencia }}</div>
        </div>
        <div class="field-item">
          <label>Fin vigencia campaña:</label>
          <div class="value-box">{{ data.campaniaFinVigencia }}</div>
        </div>

        <div class="field-item" *ngIf="!data.ocultarProporcionalidad">
          <label>Proporcionalidad:</label>
          <div class="value-box money">$ {{ formatCurrency(data.proporcionalidadValor) }}</div>
        </div>
        <div class="field-item" *ngIf="!data.ocultarLiquidacionProntoPago">
          <label>% Descuento Pronto Pago:</label>
          <div class="value-box money">{{ data.descuentoProntoPagoPorcentaje }}%</div>
        </div>

        <div class="field-item">
          <label>Cuota Inscripción:</label>
          <div class="value-box money">$ {{ formatCurrency(data.cuotaInscripcionValor) }}</div>
        </div>
        <div class="field-item">
          <label>Tarifa como asociado:</label>
          <div class="value-box money">$ {{ formatCurrency(data.tarifaComoAsociadoValor) }}</div>
        </div>
      </div>
    </section>

    <section class="detalle-right" *ngIf="!data.ocultarLiquidacionProntoPago">
      <div *ngIf="cargandoDetalleCampania" class="detalle-loading">Cargando detalle de campaña…</div>
      <p *ngIf="errorDetalleCampania" class="detalle-error">{{ errorDetalleCampania }}</p>
      <p class="nota-iva-incluido" role="note">Valores con IVA incluido*</p>
      <div class="table-wrapper">
        <table class="detalle-table">
          <thead>
            <tr>
              <th>MES</th>
              <th>DESCUENTO CON CAMPAÑA</th>
              <th>VALOR MES</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of detalleMeses">
              <td>MES {{ row.mes }}</td>
              <td>{{ row.descuentoCampaniaPorcentaje }} %</td>
              <td>$ {{ formatCurrency(row.valorMes) }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="totales">
        <div class="total-row">
          <span>TOTAL</span>
          <strong>$ {{ formatCurrency(totalSinDescuentoProntoPago) }}</strong>
        </div>
        <div class="total-row">
          <span>DESCUENTO PRONTO PAGO</span>
          <strong>$ {{ formatCurrency(valorDescuentoProntoPago) }}</strong>
        </div>
        <div class="total-row">
          <span>TOTAL CON DESCUENTO</span>
          <strong>$ {{ formatCurrency(totalConDescuento) }}</strong>
        </div>
      </div>
    </section>
  </div>
</div>
